
import LoleSize from '@/components/size/lole-size-v2'
export default {
  components: {
    LoleSize,
  },
  props: {
    wording: {
      type: Object,
      required: true,
    },
    product: {
      type: Object,
      required: true,
    },
    noSelectedSize: {
      type: Boolean,
      default: false,
    },
    selectedSize: {
      type: Object,
      default: () => {},
    },
  },
}
